import Service from '@ekd/portal-connector/dist/Service';
import { getEnv } from '../../../common/utils/getEnv';
import { isObjectEmpty } from '../../../common/utils/helpers';
import { Config } from '../types/channel';

class ChannelConfigService extends Service {
  /**
   * Fetch configuration
   */
  public async fetch<Response extends Config>(id: string) {
    try {
      const apiProvider = this.createProvider('HTTP');

      const config = await apiProvider.request<Response>({
        url: getEnv('configApi'),
        params: {
          site: id,
        },
        timeout: 3000,
      });

      if (!config?.settings) {
        return null;
      }

      config.settings.domain = id;

      return config;
    } catch {
      return null;
    }
  }

  /**
   * Loop through configurations synchronously and return multiple configurations filtered by id
   */
  public async fetchTogether<Response extends Config>(idList: string[]) {
    const response = await Promise.allSettled(idList.map(async (id: string) => this.fetch<Response>(id)));

    const result = response.reduce((result: Record<string, Response>, data) => {
      if (data.status === 'fulfilled' && data.value) {
        const { domain } = data.value.settings;
        result[domain] = data.value;
      }

      return result;
    }, {});

    return !isObjectEmpty(result) ? result : null;
  }
}

export const channelConfigService = new ChannelConfigService();
